import parse from "html-react-parser"
const htmlparser2 = require("htmlparser2")

export function useHtmlParser(htmlStr) {
  if (!htmlStr) return null
  let content = ""
  let isScript = false
  const parser = new htmlparser2.Parser({
    onopentag(tagname, attribs) {
      if (tagname !== "script") {
        let attribList = ""
        for (let a in attribs) {
          if (a !== "style") attribList += ` ${a}="${attribs[a]}"`
        }
        content += `<${tagname === "div" ? "p" : tagname}${attribList}>`
      } else isScript = true
    },
    ontext(text) {
      if (!isScript) content += text.replace("&nbsp;", " ")
    },
    onclosetag(tagname) {
      if (tagname !== "script") content += `</${tagname}>`
      else isScript = false
    },
  })
  parser.write(htmlStr)
  parser.end()
  return parse(content)
}

export default useHtmlParser